import { render, staticRenderFns } from "./InboundAddNewProduct.template.vue?vue&type=template&id=9c7db2b6&scoped=true&"
var script = {}
import style0 from "./InboundAddNewProduct.template.vue?vue&type=style&index=0&id=9c7db2b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7db2b6",
  null
  
)

export default component.exports